import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ReserveUpdateFormComponent } from './reserve-update-form/reserve-update-form.component';

const routes: Routes = [
  {
    path: 'ficha/:uuid',
    component: RegistrationFormComponent,
  },
  {
    path: 'reserva/:uuid/:id_externo/atualizar',
    component: ReserveUpdateFormComponent,
    title: 'Atualização de Reserva | JFL Living'
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
